import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IframeRoutingModule } from './iframe-routing.module';
import { IframeComponent } from './iframe/iframe.component';
import { FlexLayoutModule } from '@angular/flex-layout';


@NgModule({
  declarations: [IframeComponent],
  imports: [
    CommonModule,
    IframeRoutingModule,
    FlexLayoutModule
  ]
})
export class IframeModule { }
